import React, { Fragment } from 'react'
import { LoadingComponent, MemberTypeBadge, NotFound } from '@pga/pga-component-library'
import { Query } from 'react-apollo'
import { Container, Row } from 'reactstrap'
import { path } from 'ramda'
import styled from 'styled-components'
import { getMemberByUid } from './query'

import FacilityHero from '../assets/hero-facility.jpg'
import ProfileImg from '../assets/profileImage.svg'
import PageHeaderWithImage from '../common/PageHeaderWithImage'
import MemberInfo from './MemberInfo'
import MemberLogo from './MemberLogo'
import Credentials from './Credentials'
import { TitleWrapper, SubTitle, Title } from '../common/PageHeaderWithImage/Title'
import PersonalInfo from './PersonalInfo'
import useGetObject from '../../utils/algolia/useGetObject'

const MemberBadges = styled.div`
  @media screen and (min-width: 768px) {
    flex-grow: 1;
    text-align: end;
  }
`

const RSContainer = styled(Container)`
  margin-bottom: 30px;
`

const ImgWrapper = styled.div`
  background-color: white;
  flex-basis: 25%;
  width: 100%;
  min-width: 215px;
  min-height: 145px;
  @media (max-width: 767px) {
    min-height: 75px;
  }
`

const Img = styled.img`
  width: 210px;
  height: 210px;
  margin-bottom: 15px;
  position: absolute;
  top: -120px;
  object-fit: cover;
  @media (max-width: 767px) {
    left: calc(50% - 105px);
    top: -135px;
  }
`

const MemberInfoWrapper = styled(Container)`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media screen and (min-width: 768px) {
    justify-content: space-between;
    padding-top: unset;
  }
  @media (max-width: 575.98px) {
    justify-content: center;
  }
`

const FloatingRow = styled(Row)`
  @media (min-width: 768px) and (max-width: 991px) {
    width: 100%;
    position: absolute;
    left: 25px;
    bottom: -15px;
    padding-bottom: 5px;
  }
  @media (max-width: 767px) {
    width: auto;
    margin: auto;
  }
`

const TitlesRow = styled(Row)`
  @media (max-width: 990px) {
    margin-bottom: 70px;
  }
  @media (max-width: 767px) {
    margin-bottom: 15px;
    justify-content: center;
  }
`

const getDefaultImage = event => { event.target.src = ProfileImg }

export const RenderMember = ({ data }) => {
  return (
    <Fragment>
      <PageHeaderWithImage
        heroSrc={FacilityHero}
        heroAlt='facility'
      >
        <ImgWrapper>
          <Img
            onError={(event) => getDefaultImage(event)}
            src={data.photo || ProfileImg}
            alt='photo'
          />
        </ImgWrapper>
        <MemberInfoWrapper>
          <TitlesRow>
            <TitleWrapper>
              <Title>{data.displayName}</Title>
              {data.class !== 'F' && <SubTitle>{data.memberClassDescription}</SubTitle>}
            </TitleWrapper>
            <MemberBadges>
              <MemberTypeBadge type={data.type} />
              <MemberLogo me={data} />
            </MemberBadges>
          </TitlesRow>
          <FloatingRow>
            <PersonalInfo data={data} />
          </FloatingRow>
        </MemberInfoWrapper>
      </PageHeaderWithImage>
      <RSContainer>
        <MemberInfo hit={data} />
      </RSContainer>
      <Credentials data={data} />
    </Fragment>
  )
}

export const getReturnedMember = (data, loading, error) => {
  if (loading) return <LoadingComponent />
  const member = path(['memberByUid'], data)
  if (!loading && !member) return <NotFound />
  if (data) {
    const viewProfilePublic = path(['memberByUid', 'viewingPermissions', 'viewProfilePublic'], data)
    return (
      viewProfilePublic
        ? <RenderMember data={member} />
        : <NotFound />
    )
  }
}

export const GetMemberByUid = ({ id }) => (
  <Query errorPolicy='all' query={getMemberByUid} variables={{ id }}>
    {({ data, loading, error }) => getReturnedMember(data, loading, error)}
  </Query>
)

export default ({ match }) => {
  const [data, loading, error] = useGetObject(match.params.id) // eslint-disable-line
  if (loading) return <LoadingComponent />
  if (error) return <NotFound />
  return <GetMemberByUid id={match.params.id} />
}
